import { createAction, props } from '@ngrx/store';
import { CaseState, CaseStatusesEnum } from '../../interfaces/interfaces';
import { ICaseStatusLogs } from '../../components/case-card/interfaces/case-card-interfaces';

export const initialState: CaseState = {
  case: {
    caseType: null,
    id: null,
    uid: null,
    caseNo: null,
    caseDate: null,
    recordType: null,
    caseStatus: null,
    appointmentStatus: null,
    appointmentStartDate: null,
    appointmentEndDate: null,
    appointmentDuration: null,
    createdAt: null,
    patientInformations: null,
    caseInformations: null,
    addressInformations: null,
    serviceInformations: null,
    paymentInformations: [],
    documentInformations: null,
    vehicleStatusInformations: null,
    inspectionInformation: null,
    callCardInformations: null,
    cancelReason: null,
    cancelDescription: null,
    isCaseApproved: null,
    isSendCerebral: null,
    isSendLabmed: false,
    patient: {
      id: null,
      firstName: '',
      lastName: '',
      category: [],
      gender: null,
      age: null,
      contacts: [],
      addresses: [],
    },
    mainVehicleLog: null,
    plannedVehicle:null,
    plannedStaff:null,
    
    childAppointments:  [],
    parentAppointment:  null,
    parentAppointmentId: null,
    isExcelData: false,
  },
  loading: false,
  blackList: [],
  error: null,
  isReadonly: false,
  userInFile: null,
};

export const resetCase = createAction('[Case] Reset Case');

export const setBlackList = createAction(
  '[Case] Black List',
  props<{ blackList: string[] }>()
);

export const setCaseStatus = createAction(
  '[Case] SetStatus',
  props<{ status: CaseStatusesEnum }>()
);

export const setAppointmentStatus = createAction(
  '[Appointment] Set Status',
  props<{ status: CaseStatusesEnum }>()
);

export const setCancelInformations = createAction(
  '[Case] Set Case Cancel Informations',
  props<{ cancelReason: number; cancelDescription: string }>()
);

export const setCaseApprove = createAction(
  '[Case] Set Case Approve',
  props<{ isApproved: boolean }>()
);

export const setReadOnly = createAction(
  '[Case] SET READONLY',
  props<{ caseId: number }>()
);

export const setReadOnlySuccess = createAction(
  '[Case] SET READONLY SUCCESS',
  props<{ lock: boolean; username: string }>()
);

export const removeReadOnly = createAction(
  '[Case] REMOVE READONLY',
  props<{ caseId: number }>()
);

export const removeReadOnlySuccess = createAction(
  '[Case] REMOVE READONLY SUCCESS',
  props<{ lock: boolean; username: string }>()
);

export const loadCase = createAction(
  '[Case] Load Case',
  props<{ id: number }>()
);
export const loadCaseSuccess = createAction(
  '[Case] Load Case Success',
  props<{ data: any }>()
);
export const loadCaseFailure = createAction(
  '[Case] Load Case Failure',
  props<{ error: string }>()
);

export const caseSuccess = createAction(
  '[Case]  Case Success',
  props<{ data: any }>()
);
export const caseFailure = createAction(
  '[Case]  Case Failure',
  props<{ error: string }>()
);

export const caseSendCerebral = createAction(
  '[Case] Send Cerebral',
  props<{ isSendCerebral: boolean }>()
);

export const caseSetMainVehicleLog = createAction(
  '[Case] Set Main Vehicle Log',
  props<{ log: ICaseStatusLogs | null }>()
);

export const setLoading = (state: CaseState) => ({
  ...state,
  loading: true,
  error: null,
});

export const setLoadingSuccess = (
  state: CaseState,
  { data }: { data: any }
) => {
  return {
    ...state,
    case: {
      ...state.case,
      patientInformations: {
        patientNo: data?.patientInformations?.patient?.id ?? null,
        firstName: data?.patientInformations?.firstName ?? null,
        lastName: data?.patientInformations?.lastName ?? null,
        idNumber: data?.patientInformations?.idNumber ?? null,
        unidentified: data?.patientInformations?.unidentified ?? null,
        birthDate: data?.patientInformations?.birthDate ?? null,
        age: data?.patientInformations?.age ?? null,
        bloodGroup: data?.patientInformations?.bloodGroup?.valueObject?.id
          ?.value
          ? {
              label:
                data?.patientInformations?.bloodGroup?.valueObject?.name?.value,
              value:
                data?.patientInformations?.bloodGroup?.valueObject?.id?.value,
            }
          : null,
        country: data?.patientInformations?.country?.id
          ? {
              label: data?.patientInformations?.country?.name,
              value: data?.patientInformations?.country?.id,
            }
          : null,
        gender: data?.patientInformations?.gender ?? null,
        isForeignNational: data?.patientInformations?.isForeignNational ?? null,
        passportNo: data?.patientInformations?.passportNo ?? null,
        medicalRecords:
          data?.patientInformations?.medicalRecords?.map((item: any) => {
            return {
              id: item?.id,
              icdCodeId: item?.icdCode?.id,
              icdCodeName: item?.icdCode?.name,
              icdCode: item?.icdCode?.code,
              description: item?.description,
            };
          }) ?? [],
        contacts: data?.patientInformations?.contacts,
        description: data?.patientInformations?.description ?? null,
        idNumberVerified: data?.patientInformations?.idNumberVerified ?? false,
      },
      patient: {
        firstName: data?.patientInformations?.firstName ?? null,
        lastName: data?.patientInformations?.lastName ?? null,
        id: data?.patientInformations?.patient?.id ?? null,
        category: data?.patientInformations?.patient?.category ?? [],
        gender: data?.patientInformations?.gender,
        age: data?.patientInformations?.age,
        contacts: data?.patientInformations?.patient?.contacts ?? [],
        addresses: data?.patientInformations?.patient?.addresses ?? [],
        specialCategoryTags: data?.patientInformations?.patient?.specialCategoryTags ?? [],
        patientFullName: data?.caseInformations?.patientFullName ?? null,
      },
      caseInformations: {
        assuranceType: data?.caseInformations?.assuranceType?.valueObject?.id
          ?.value
          ? {
              label:
                data?.caseInformations?.assuranceType?.valueObject?.name?.value,
              value:
                data?.caseInformations?.assuranceType?.valueObject?.id?.value,
            }
          : null,
        freeType: data?.caseInformations?.freeType?.valueObject?.id?.value
          ? {
              label: data?.caseInformations?.freeType?.valueObject?.name?.value,
              value: data?.caseInformations?.freeType?.valueObject?.id?.value,
            }
          : null,
        priceType: data?.caseInformations?.priceType?.valueObject?.id?.value
          ? {
              label:
                data?.caseInformations?.priceType?.valueObject?.name?.value,
              value: data?.caseInformations?.priceType?.valueObject?.id?.value,
            }
          : null,
        causeReason: data?.caseInformations?.causeReason?.valueObject?.id?.value
          ? {
              label:
                data?.caseInformations?.causeReason?.valueObject?.name?.value,
              value:
                data?.caseInformations?.causeReason?.valueObject?.id?.value,
            }
          : null,
        serviceReason: data?.caseInformations?.serviceReason?.valueObject?.id
          ?.value
          ? {
              label:
                data?.caseInformations?.serviceReason?.valueObject?.name?.value,
              value:
                data?.caseInformations?.serviceReason?.valueObject?.id?.value,
            }
          : null,
        protocolNo: data?.caseInformations?.protocolNo ?? null,
        labmedNo: data?.caseInformations?.labmedNo ?? null,
        memberNo: data?.caseInformations?.memberNo ?? null,
        memberContractNo: data?.caseInformations?.memberContractNo ?? null,
        memberFullname: data?.caseInformations?.memberFullname ?? null,
        triage: data?.caseInformations?.triage?.valueObject?.id?.value
          ? {
              label: data?.caseInformations?.triage?.valueObject?.name?.value,
              value: data?.caseInformations?.triage?.valueObject?.id?.value,
            }
          : null,
        userNote: data?.caseInformations?.userNote ?? null,
        complaint: data?.caseInformations?.complaint ?? null,
        institution: data?.caseInformations?.institution?.id
          ? {
              label: data?.caseInformations?.institution?.signboard,
              value: data?.caseInformations?.institution?.id,
            }
          : null,
        diagnoses:
          data?.caseInformations?.diagnoses?.map((item: any) => {
            return {
              id: item?.id,
              icdCodeId: item?.icdCode?.id,
              icdCodeName: item?.icdCode?.name,
              icdCode: item?.icdCode?.code,
              description: item?.description,
              savedType: item?.savedType,
            };
          }) ?? [],
        vitalSigns:
          data?.caseInformations?.vitalSigns?.map((item: any) => {
            return {
              id: item?.id,
              parameter: {
                label: item?.parameter?.valueObject?.name?.value,
                value: item?.parameter?.valueObject?.id?.value,
              },
              input1: item?.input1,
              input2: item?.input2,
              numberOfInput: item?.parameter?.valueObject?.numberOfInput?.value,
              unit: item?.parameter?.valueObject?.unit?.value,
            };
          }) ?? [],
        staff:data?.caseInformations?.staff?.id ?? null,
        
        patientFullName: data?.caseInformations?.patientFullName ?? null,
        supportStaff: data?.caseInformations?.supportStaff ?? null,
        department: data?.caseInformations?.department ?? null,
        supplier: data?.caseInformations?.supplier ?? null,
        time: data?.caseInformations?.time ?? null,
      },
      addressInformations: {
        pickupInstitution: data?.addressInformations?.pickupInstitution?.id
          ? {
              label: data?.addressInformations?.pickupInstitution?.signboard,
              value: data?.addressInformations?.pickupInstitution?.id,
            }
          : null,
        dropoffInstitution: data?.addressInformations?.dropoffInstitution?.id
          ? {
              label: data?.addressInformations?.dropoffInstitution?.signboard,
              value: data?.addressInformations?.dropoffInstitution?.id,
            }
          : null,
        pickupAddress: data?.addressInformations?.pickupAddress ?? null,
        dropoffAddress: data?.addressInformations?.dropoffAddress ?? null,
        dropoffInstitutionApproval:
          data?.addressInformations?.dropoffInstitutionApproval,
        dropoffInstitutionDescription:
          data?.addressInformations?.dropoffInstitutionDescription,
      },
      serviceInformations: {
        lastPrice: data?.lastPrice ?? null,
        bottomDiscountPrice: data?.bottomDiscountPrice ?? null,
        totalDiscountPrice: data?.totalDiscountPrice ?? null,
        totalProvisionPrice: data.totalProvisionPrice ?? null,
        totalPrice: data.totalPrice ?? null,
        provisionDescription: data?.provisionDescription ?? null,
        provisionInstitution: data?.provisionInstitution?.id ?? null,
        provisionNo: data?.provisionNo ?? null,
        numberOfServices: data?.numberOfServices ?? null,
        bottomDiscountDescription: data?.bottomDiscountDescription ?? null,
        services:
          data?.serviceInformations?.map((s: any) => {
            return {
              serviceCode: s?.serviceCode ?? null,
              serviceName: s?.serviceName ?? null,
              serviceId: s?.serviceId ?? null,
              gatePrice: s?.gatePrice ?? null,
              memberPrice: s?.memberPrice ?? null,
              quantity: s?.quantity ?? null,
              totalPrice: s?.totalPrice ?? null,
              unitPrice: s?.unitPrice ?? null,
              lastPrice: s?.lastPrice ?? null,
              priceType: s?.priceType ?? null,
              ruleOfPopups: s?.ruleOfPopups ?? null,
              givenForFree: s?.givenForFree ?? null,
              discount: {
                percentage: s?.discountPercentage ?? null,
                price: s?.discountPrice ?? null,
              },
              bottomDiscount: {
                percentage: s?.bottomDiscountPercentage ?? null,
                price: s?.bottomDiscountPrice ?? null,
              },
              provision: {
                percentage: s?.provisionPercentage ?? null,
                price: s?.provisionPrice ?? null,
              },
              flexiblePrice: {
                isFlexible: s?.flexiblePriceIsFlexible ?? false,
                price: s?.flexiblePricePrice ?? null,
              },
            };
          }) ?? [],
      },
      paymentInformations:
        data?.paymentInformations?.map((p: any) => {
          return {
            id: p?.id ?? null,
            paymentType: p?.paymentType
              ? {
                  label: p?.paymentType?.valueObject?.name?.value,
                  value: p?.paymentType?.valueObject?.id?.value,
                }
              : null,
            exchangeType: p?.exchangeType
              ? {
                  label: p?.exchangeType?.valueObject?.name?.value,
                  value: p?.exchangeType?.valueObject?.id?.value,
                }
              : null,
            staff: p?.staff
              ? {
                  label: p?.staff?.firstName + ' ' + p?.staff?.lastName,
                  value: p?.staff.id,
                }
              : null,
            institution: p?.institution
              ? {
                  label: p?.institution?.signboard,
                  value: p?.institution.id,
                }
              : null,
            provisionNo: p?.provisionNo ?? null,
            paymentDate: p?.paymentDate ?? null,
            total: p?.total ?? null,
            totalTL: p?.totalTL ?? null,
            rateOfExchange: p?.rateOfExchange ?? null,

            uuid: p?.uuid ?? null,
            payed: p?.payed ?? null,
            sipayStatus: p?.sipayStatus ?? null,
            sipaySmsSended: p?.sipaySmsSended ?? null
          };
        }) ?? [],

      callCardInformations: data?.callCards ?? null,
      id: data?.id,
      caseType: data?.caseType,
      uid: data?.uid ?? null,
      caseNo: data?.caseNo,
      createdAt: data?.createdAt ?? null,
      caseStatus: data?.caseStatus,
      appointmentStatus: data?.appointmentStatus,
      recordType: data?.recordType,
      caseDate: data?.caseDate,
      appointmentStartDate: data?.appointmentStartDate ?? null,
      appointmentEndDate: data?.appointmentEndDate ?? null,
      appointmentDuration: data?.appointmentDuration ?? null,
      cancelReason: data?.cancelReason?.valueObject?.id?.value ?? null,
      cancelDescription: data?.cancelDescription ?? null,
      isCaseApproved: data?.isCaseApproved ?? null,
      isSendCerebral: data?.isSendCerebral ?? null,
      isSendLabmed: data?.isSendLabmed ?? null,
      plannedVehicle:data?.plannedVehicle ?? null,
      plannedStaff:data?.plannedStaff ?? null,
      patientFile:{
        fileNo: data?.patientFile?.fileNo,
        id:data?.patientFile?.id,
      },
      childAppointments: data?.childAppointments ?? [],
      parentAppointment: data?.parentAppointment ?? null,
      parentAppointmentId: data?.parentAppointmentId ?? null,
      isExcelData: data?.isExcelData ?? false,

    },
    loading: false,
    error: null,
  };
};

export const setFailure = (state: CaseState, { error }: { error: string }) => {
  return {
    ...state,
    loading: false,
    error,
  };
};

export const setReadOnlyAction = (
  state: CaseState,
  data: { lock: boolean; username: string }
) => {
  return {
    ...state,
    isReadonly: data.lock ?? false,
    userInFile: data?.username ?? null,
  };
};

export const setResetCase = (state: CaseState) => ({
  case: {
    ...initialState.case,
    patient: { ...initialState.case.patient },
  },
  loading: false,
  blackList: [...initialState.blackList],
  error: null,
  isReadonly: false,
  userInFile: null,
});

export const updateBlackList = (
  state: CaseState,
  { blackList }: { blackList: string[] }
) => ({
  ...state,
  blackList: blackList,
});

export const sendCerebralSuccess = (
  state: CaseState,
  payload: {
    isSendCerebral: boolean;
  }
) => {
  return {
    ...state,
    case: {
      ...state.case,
      isSendCerebral: payload.isSendCerebral,
    },
  };
};

export const setMainVehicleLog = (
  state: CaseState,
  payload: {
    log: ICaseStatusLogs|null;
  }
) => {
  return {
    ...state,
    case: {
      ...state.case,
      mainVehicleLog: payload.log,
    },
  };
};

export const takeOverEdit = createAction(
  '[Case] TAKE OVER EDIT',
  props<{ caseId: number }>()
);

export const takeOverEditSuccess = createAction(
  '[Case] TAKE OVER EDIT SUCCESS',
  props<{ lock: boolean; username: string }>()
);

export const takeOverEditFailure = createAction(
  '[Case] TAKE OVER EDIT FAILURE',
  props<{ error: any }>()
);

export const setTakeOverEdit = (
  state: CaseState,
  { username }: { username: string }
) => {
  return {
    ...state,
    isReadonly: false,
    userInFile: username,
  };
};
